// extracted by mini-css-extract-plugin
export default {"rating":"RG-z","numberOfStars":"SG-z","count":"TG-z","barGraphSpacing":"UG-z","barGraph":"VG-z"};